import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography, Divider, Grid, OutlinedInput,
  FormControl, InputLabel, Select, MenuItem, Checkbox,
} from '@material-ui/core';
import MuiListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';


const rolesDisplay = {
  politician: 'Politiker',
  admin: 'Administrator',
  superadmin: 'Superadministrator',
  secretary: 'Sekretær',
  observer: 'Observatør',
  other: 'Andre',
};

const RoleSelection = ({
  classes,
  roles,
  chosenRoles,
  onChange,
}) => [
  <Grid item xs={12} key={1}>
    <Typography variant="body1" color="primary">Roller</Typography>
    <Typography variant="body2"><i>En bruker kan ha flere ulike type roller</i></Typography>
  </Grid>,
  <Grid item xs={12} sm={6} key={2}>
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel required id="demo-mutiple-checkbox-label">Roller</InputLabel>
      <Select
        variant="outlined"
        multiple
        input={<OutlinedInput labelWidth={50} name="par" id="outlined-par-simple" />}
        value={chosenRoles}
        onChange={onChange}
        /* input={<Input />} */
        renderValue={selected => (
          selected.map(v => (
            <Typography variant="body1" key={v}>{rolesDisplay[v]}</Typography>
          ))
        )}
        /* MenuProps={MenuProps} */
      >
        {roles.map(role => (
          <MenuItem key={role} value={role}>
            <Checkbox color="primary" checked={chosenRoles.indexOf(role) > -1} />
            <MuiListItemText primary={rolesDisplay[role]} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>,
  <Grid key={3} item xs={12}><Divider /></Grid>,
];

const styles = () => ({
  formControl: {
    width: '100%',
  },
});

RoleSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
  chosenRoles: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(RoleSelection);
